<template>
    <div>
        <div class="actions-tab in-tab">
            <b-dropdown
                variant="link"
                class="info"
                right
                toggle-class="text-decoration-none"
                no-caret
            >
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-info"></i>
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-text>
                    <div class="info-button" @click="downloadStaticFile(2)">
                        <span>
                            Режим «Мониторинг СНП»
                            <i class="icon icon-folder"></i>
                        </span>
                    </div>
                    <div class="info-title">
                        <span>Мониторинг СНП</span>
                    </div>
                    <div class="info-text">
                        <p>
                            Данный модуль предназначен для сбора и анализа
                            данных по формам мониторинга СНП по приказу Первого
                            заместителя Премьер-Министра Республики Казахстан -
                            Министра регионального развития Республики Казахстан
                            от 24 сентября 2013 года № 239/ОД. .
                        </p>
                        <div class="info-subtitle">
                            <span>Реестр</span>
                        </div>
                        <p>
                            Раздел предназначен для ведения реестра по объектам
                            образования и дорогам местного значения и для
                            просмотра самой актуальной информации.
                        </p>
                    </div>
                </b-dropdown-text>
            </b-dropdown>
            <b-dropdown
                variant="link"
                right
                toggle-class="text-decoration-none"
                no-caret
            >
                <template #button-content>
                    <div class="btn-download">
                        <div @click="downloadFile">
                            <i
                                class="icon icon-download"
                                style="color: #01ac50; margin-left: 9px"
                            ></i>
                            <span style="margin-right: 15px">Скачать</span>
                        </div>
                        <i class="icon icon-keyboard"></i>
                    </div>
                </template>
                <b-dropdown-item @click="downloadFile">Реестр</b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="filter-container">
            <b-dropdown class="filter-dropdown" variant="default" ref="drop">
                <template #button-content>
                    <span class="lc"
                        ><i class="icon icon-filter"></i>Фильтр</span
                    >
                    <span class="rc"><i class="icon icon-keyboard"></i></span>
                </template>
                <div>
                    <div class="top-content">
                        <span>Параметры фильтра</span>
                        <i
                            class="icon icon-close"
                            @click="$refs.drop.hide(true)"
                        ></i>
                    </div>
                    <div class="filter-block">
                        <b-form-group :label="sgpDoc[0].name_ru">
                            <multiselect
                                v-model="templateVal"
                                :options="templateArr.map((temp) => temp.name)"
                                placeholder="Выберите шаблон"
                                :show-labels="false"
                                @input="handleTemplateSelect"
                            />
                        </b-form-group>
                    </div>
                    <div class="filter-block">
                        <b-form-group :label="sgpDoc[1].name_ru">
                            <multiselect
                                v-model="registryVal"
                                :options="registryArr"
                                placeholder="Выберите реестр"
                                :allow-empty="false"
                                :show-labels="false"
                                label="name"
                                @input="handleRegistrySelect"
                            />
                        </b-form-group>
                    </div>
                    <div class="filter-block">
                        <b-form-group :label="sgpDoc[5].name_ru">
                            <multiselect
                                v-model="yearVal"
                                :options="yearsArr"
                                placeholder="Выберите год"
                                :allow-empty="false"
                                :show-labels="false"
                            />
                        </b-form-group>
                    </div>
                    <div class="filter-block">
                        <b-form-group :label="sgpDoc[2].name_ru">
                            <multiselect
                                v-model="regionVal"
                                :options="
                                    regions.filter(
                                        (item) => item.nameRu !== 'Все'
                                    )
                                "
                                placeholder="Выберите район"
                                :allow-empty="false"
                                :show-labels="false"
                                label="nameRu"
                                @input="handleRegionSelect"
                            />
                        </b-form-group>
                    </div>
                    <template v-if="registryVal && !isRoadsRegistry">
                        <div class="filter-block">
                            <b-form-group :label="sgpDoc[3].name_ru">
                                <multiselect
                                    v-model="districtVal"
                                    :options="districtArr"
                                    placeholder="Выберите сельский округ"
                                    :allow-empty="false"
                                    :show-labels="false"
                                    label="nameRu"
                                    @input="handleDistrictSelect"
                                />
                            </b-form-group>
                        </div>
                        <div
                            class="filter-block"
                            v-if="registryVal && !isRoadsRegistry"
                        >
                            <b-form-group :label="sgpDoc[4].name_ru">
                                <multiselect
                                    v-model="snpVal"
                                    :options="districtVal ? snpArr : []"
                                    placeholder="Выберите СНП"
                                    :allow-empty="false"
                                    :show-labels="false"
                                    label="nameRu"
                                    @input="handleSnpSelect"
                                />
                            </b-form-group>
                        </div>
                    </template>
                </div>
                <div class="filter-block" style="margin-top: 30px">
                    <b-button variant="primary" @click="applyFilter"
                        >Применить</b-button
                    >
                    <b-button variant="secondary" @click="resetFilter"
                        >Сбросить</b-button
                    >
                </div>
            </b-dropdown>
            <div class="selected-snp" style="flex: 1">
                <span v-if="selectedRegionLabel">{{
                    selectedRegionLabel
                }}</span>
                <span v-else>{{ selectedSnpLabel }}</span>
                <template v-if="reconciliation && reconciliation.status">
                    <div
                        v-if="reconciliation.status === 'IN_PROCESS'"
                        class="authorHistory__status ml-4"
                        :class="reconciliation.status"
                    >
                        <span>{{
                            $t(
                                `modules.monitoringSnp.statuses.${reconciliation.status}`
                            )
                        }}</span>
                        <span>{{ ` - ${progress}%` }}</span>
                    </div>
                    <b-dropdown
                        v-else
                        class="authorHistory--passport"
                        variant="link"
                        toggle-class="text-decoration-none"
                        no-caret
                    >
                        <template #button-content>
                            <span
                                class="authorHistory__status ml-4"
                                :class="reconciliation.status"
                                @click="loadHistory"
                            >
                                <span>{{ getCurrentStatusName() }}</span>
                                <span
                                    v-if="
                                        reconciliation.status ===
                                        'SEND_TO_REPROCESS'
                                    "
                                >
                                    {{ ` - ${progress}%` }}
                                </span>
                            </span>
                        </template>
                        <div>
                            <b-spinner
                                v-if="historyLoading"
                                small
                                label="Small Spinner"
                            ></b-spinner>
                            <template v-else>
                                <div
                                    class="authorHistory__list"
                                    v-if="historyData.length > 0"
                                >
                                    <div
                                        v-for="item of historyData"
                                        class="row authorHistory__item"
                                        :key="item.id"
                                    >
                                        <div
                                            class="col-5 authorHistory__status"
                                            :class="item.toStatus"
                                        >
                                            <!-- {{ $t(`modules.monitoringSnp.shortStatuses.${item.toStatus}`) }} -->
                                            {{ item.name_ru }}
                                        </div>
                                        <div class="col-3">
                                            {{ item.createdBy }}
                                        </div>
                                        <div class="col-4">
                                            {{ formatDate(item.createdAt) }}
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="authorHistory__notFound">
                                    История не найдена
                                </div>
                            </template>
                        </div>
                    </b-dropdown>
                </template>
            </div>
            <div class="filter-actions">
                <!-- <b-button
                    v-if="roles.DISTRICT_DEPARTMENTS || roles.ADMIN"
                    variant="success"
                    @click="handleSave"
                    :disabled="!canSaveOrAdd()"
                >
                    Сохранить
                </b-button> -->
                <b-button
                    v-if="
                        roles.ADMIN ||
                        (isSchoolsSelectedRegistry && roles.VILLAGE) ||
                        (isRoadsSelectedRegistry &&
                            roles.DISTRICT_DEPARTMENTS)
                    "
                    variant="primary"
                    :disabled="!canSendToApprove()"
                    @click="sendToApprove"
                >
                    На согласование
                </b-button>
                <b-button
                    v-if="
                        roles.DISTRICT_DEPARTMENTS ||
                        roles.DISTRICT ||
                        roles.ADMIN
                    "
                    variant="success"
                    :disabled="!canReconcile()"
                    @click="reconcile"
                >
                    Согласовать
                </b-button>
                <b-button
                    v-if="
                        roles.REGION_DEPARTMENTS || roles.REGION || roles.ADMIN
                    "
                    variant="success"
                    :disabled="!canApprove()"
                    @click="approve"
                >
                    Утвердить
                </b-button>
                <b-button
                    v-if="
                        roles.REGION_DEPARTMENTS ||
                        roles.REGION ||
                        roles.DISTRICT ||
                        roles.ADMIN ||
                        (isSchoolsSelectedRegistry &&
                            roles.DISTRICT_DEPARTMENTS)
                    "
                    variant="secondary"
                    :disabled="!canSendToReprocess()"
                    @click="sendToReprocess"
                >
                    На доработку
                </b-button>
                <!-- <b-button variant="primary" @click="unloadRegistry">Выгрузить</b-button> -->
                <b-button
                    variant="success"
                    @click="createRegistry()"
                    v-if="
                        roles.ADMIN ||
                        (isSchoolsSelectedRegistry && roles.VILLAGE) ||
                        (isRoadsSelectedRegistry &&
                            roles.DISTRICT_DEPARTMENTS)
                    "
                    :disabled="!canSaveOrAdd()"
                >
                    <i class="icon icon-plus-circle"></i> Добавить
                </b-button>
                <!-- <b-button variant="success" @click="handleSaveTemplate()">Сохранить шаблон</b-button> -->
            </div>
        </div>
        <div class="table-container" v-if="!loading">
            <div class="b-table-sticky-header table-responsive-true">
                <table
                    class="table b-table table-bordered b-table-no-border-collapse constructor-table"
                >
                    <thead>
                        <tr class="text-center" v-if="selectedRegistry">
                            <th></th>
                            <th>{{ selectedRegistry.name }}</th>
                            <th v-if="selectedRegistry.name === 'Реестр школ'">
                                СНП
                            </th>
                            <template v-for="label of [0, 1, 2, 3, 4]">
                                <th
                                    :key="label"
                                    :class="`labelItem_${label} cursor-point`"
                                    @click="reportTypeModal(label)"
                                    v-if="currentHeads[label] === undefined"
                                >
                                    Показатель
                                    <i
                                        class="text-right icon icon-keyboard icon-rotate-90"
                                    ></i>
                                </th>
                                <th
                                    :key="label"
                                    :class="`labelItem_${label} cursor-point`"
                                    @click="reportTypeModal(label)"
                                    v-else
                                >
                                    {{ currentHeads[label].desc }}
                                    <i
                                        class="text-right icon icon-keyboard icon-rotate-90"
                                    ></i>
                                </th>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="item of globalArr">
                            <tr :key="item.id">
                                <td></td>
                                <td>
                                    <a
                                        href="javascript:void(0)"
                                        @click="
                                            getSchoolInfo(
                                                item,
                                                isAfterSelectedTemp
                                            )
                                        "
                                        >{{ item.name || "Имя школы" }}</a
                                    >
                                </td>
                                <td
                                    v-if="
                                        selectedRegistry &&
                                        selectedRegistry.name === 'Реестр школ'
                                    "
                                >
                                    {{ item.snp }}
                                </td>
                                <template v-for="label of [0, 1, 2, 3, 4]">
                                    <td
                                        :key="label"
                                        :style="{ backgroundColor: '#fff5da' }"
                                        v-if="item.fields[label] !== undefined"
                                    >
                                        <template>
                                            {{ item.fields[label].value }}
                                        </template>
                                    </td>
                                    <th
                                        :key="label"
                                        :style="{ backgroundColor: '#fff5da' }"
                                        v-else
                                    ></th>
                                </template>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else class="spinner">
            <b-spinner
                variant="info"
                style="width: 3rem; height: 3rem"
                label="Large Spinner"
            ></b-spinner>
        </div>
        <b-modal
            id="registry-field"
            v-model="createModalVisible"
            size="lg"
            title="Карточка объекта"
            centered
            content-class="modal-forms"
            body-class="constructor-field"
        >
            <template>
                <div class="required-hint">
                    * - Обязательно для редактирования
                </div>
                <b-form
                    inline
                    class="registry-create"
                    id="frm"
                    ref="createRegistryForm"
                >
                    <template v-for="(info, index) in formRegistry">
                        <b-input-group
                            class="mb-2 no-wrap"
                            :class="
                                info.description !== 'Район' &&
                                info.description !== 'СНП' &&
                                'no-wrap'
                            "
                            style="width: 100%"
                            :key="
                                info.column_number + ' ' + index + ' ' + info.id
                            "
                            v-if="
                                notVisible.indexOf(info.description) === -1 &&
                                info.description !== 'Сельский округ' &&
                                info.description !== 'Область'
                            "
                        >
                            <template v-if="info.description === 'Район'">
                                <label class="mr-sm-2"
                                    ><span
                                        :class="{
                                            required: isRequired(
                                                info.description
                                            ),
                                        }"
                                        >{{ info.description }}</span
                                    >
                                </label>
                                <div style="padding-bottom: 13px">
                                    <multiselect
                                        v-model="createRegionVal"
                                        :options="
                                            regions.filter(
                                                (item) =>
                                                    item.nameRu !== 'Все' &&
                                                    regionsKatoCodes.includes(
                                                        String(item.code)
                                                    )
                                            )
                                        "
                                        placeholder="Выберите район"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        label="nameRu"
                                        :name="`item_field_${info.id}`"
                                        :id="`item_field_${info.id}`"
                                        @input="handleFromRegionSelect"
                                        :disabled="true"
                                    />
                                </div>
                                <b-input-group
                                    class="mb-2 no-wrap"
                                    style="width: 100%"
                                    v-if="registryVal && !isRoadsRegistry"
                                >
                                    <label class="mr-sm-2"
                                        ><span
                                            :class="{
                                                required:
                                                    isRequired(
                                                        'Сельский округ'
                                                    ),
                                            }"
                                            >Сельский округ</span
                                        ></label
                                    >
                                    <div>
                                        <multiselect
                                            v-model="createDistrictVal"
                                            :options="
                                                createDistrictArr.filter(
                                                    (item) =>
                                                        item.nameRu !== 'Все'
                                                )
                                            "
                                            placeholder="Выберите сельский округ"
                                            :allow-empty="false"
                                            :show-labels="false"
                                            label="nameRu"
                                            name="districtName"
                                            id="districtId"
                                            @input="handleFromDistrictSelect"
                                            :disabled="!canSaveOrAdd()"
                                        />
                                    </div>
                                </b-input-group>
                            </template>
                            <template v-else-if="info.description === 'СНП'">
                                <label class="mr-sm-2"
                                    ><span
                                        :class="{
                                            required: isRequired(
                                                info.description
                                            ),
                                        }"
                                        >{{ info.description }}</span
                                    ></label
                                >
                                <div>
                                    <multiselect
                                        v-model="createSnpVal"
                                        :options="
                                            createSnpArr.filter(
                                                (item) => item.nameRu !== 'Все'
                                            )
                                        "
                                        placeholder="Выберите СНП"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        :id="`item_field_${info.id}`"
                                        :name="`item_field_${info.id}`"
                                        label="nameRu"
                                        :disabled="!canSaveOrAdd()"
                                    />
                                </div>
                            </template>
                            <template v-else>
                                <label class="mr-sm-2"
                                    ><span
                                        :class="{
                                            required: isRequired(
                                                info.description
                                            ),
                                        }"
                                        >{{ info.description }}</span
                                    ></label
                                >
                                <template
                                    v-if="
                                        info.params &&
                                        !info.params.editable &&
                                        !info.isList
                                    "
                                >
                                    <div class="px-2">
                                        {{ info.value }}
                                    </div>
                                </template>
                                <template
                                    v-else-if="info.params && info.isList"
                                >
                                    <div>
                                        <multiselect
                                            v-model="info.value"
                                            :options="
                                                info.params.values.map(
                                                    (item) => ({ value: item })
                                                )
                                            "
                                            placeholder="Выберите"
                                            :allow-empty="
                                                info.params.multiple_choice
                                            "
                                            :show-labels="false"
                                            :id="`item_field_${info.column_number}`"
                                            :name="`item_field_${info.column_number}`"
                                            label="value"
                                            :disabled="!canSaveOrAdd()"
                                            :multiple="
                                                info.params.multiple_choice
                                            "
                                            :close-on-select="
                                                !info.params.multiple_choice
                                            "
                                            track-by="value"
                                            @input="refresh()"
                                        >
                                            <template
                                                slot="selection"
                                                slot-scope="{ values, isOpen }"
                                                ><span
                                                    class="multiselect__single"
                                                    v-if="
                                                        info.params
                                                            .multiple_choice &&
                                                        values.length
                                                    "
                                                    v-show="!isOpen"
                                                    >{{
                                                        values
                                                            .map(
                                                                (item) =>
                                                                    item.value
                                                            )
                                                            .filter(
                                                                (item) => !!item
                                                            )
                                                            .join(", ")
                                                    }}
                                                </span></template
                                            >
                                        </multiselect>
                                    </div>
                                </template>
                                <template v-else>
                                    <b-form-input
                                        class="mr-sm-8"
                                        size="lg"
                                        :type="
                                            info.params &&
                                            info.params.data_type &&
                                            (info.params.data_type ===
                                                'integer' ||
                                                info.params.data_type ===
                                                    'float')
                                                ? 'number'
                                                : 'text'
                                        "
                                        :id="`item_field_${info.columnNumber}`"
                                        :name="`item_field_${info.columnNumber}`"
                                        v-model="info.value"
                                        :disabled="!canSaveOrAdd()"
                                        @input="
                                            handleChangeValue(
                                                info,
                                                index,
                                                'create'
                                            )
                                        "
                                        :class="
                                            info.params &&
                                            controlMap[index] &&
                                            'control-error'
                                        "
                                        @keypress="
                                            (e) =>
                                                info.params &&
                                                info.params.data_type &&
                                                info.params.data_type ===
                                                    'integer' &&
                                                (e.key === '.' ||
                                                    e.key === '-') &&
                                                e.preventDefault()
                                        "
                                        @mousewheel="(e) => e.preventDefault()"
                                    />
                                </template>
                            </template>
                        </b-input-group>
                    </template>
                </b-form>
            </template>
            <template #modal-footer style="justify-content: left">
                <b-button
                    variant="primary"
                    class="float-left"
                    @click="saveRegistry"
                    >Сохранить</b-button
                >
                <b-button variant="light" @click="createModalVisible = false"
                    >Отменить</b-button
                >
            </template>
        </b-modal>

        <b-modal
            id="registry-field"
            v-model="editModalVisible"
            size="lg"
            title="Карточка объекта"
            centered
            content-class="modal-forms"
            body-class="constructor-field"
        >
            <template>
                <div class="required-hint">
                    * - Обязательно для редактирования
                </div>

                <b-form
                    v-if="selectedSchool"
                    inline
                    class="registry-create"
                    id="editFrm"
                    ref="editRegistryForm"
                >
                    <template v-for="(info, index) of selectedSchool.fields">
                        <b-input-group
                            class="mb-2"
                            style="width: 100%"
                            :class="'no-wrap'"
                            :key="info.column_number + ' ' + index"
                            v-if="info.head !== 'Сельский округ'"
                        >
                            <template v-if="info.head === 'Район'">
                                <label class="mr-sm-2"
                                    ><span
                                        :class="{
                                            required: isRequired(info.head),
                                        }"
                                        >{{ info.head }}</span
                                    ></label
                                >
                                <div style="padding-bottom: 13px">
                                    <multiselect
                                        v-model="editRegionVal"
                                        :options="
                                            regions.filter(
                                                (item) =>
                                                    item.nameRu !== 'Все' &&
                                                    regionsKatoCodes.includes(
                                                        String(item.code)
                                                    )
                                            )
                                        "
                                        placeholder="Выберите район"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        label="nameRu"
                                        :name="`item_field_${info.column_number}`"
                                        :id="`item_field_${info.column_number}`"
                                        @input="handleFromRegionSelect"
                                        :disabled="true"
                                    />
                                </div>
                                <b-input-group
                                    class="mb-2 no-wrap"
                                    style="width: 100%"
                                    v-if="registryVal && !isRoadsRegistry"
                                >
                                    <label class="mr-sm-2"
                                        ><span
                                            :class="{
                                                required:
                                                    isRequired(
                                                        'Сельский округ'
                                                    ),
                                            }"
                                            >Сельский округ</span
                                        ></label
                                    >
                                    <div>
                                        <multiselect
                                            v-model="editDistrictVal"
                                            :options="
                                                editDistrictArr.filter(
                                                    (item) =>
                                                        item.nameRu !== 'Все'
                                                )
                                            "
                                            placeholder="Выберите сельский округ"
                                            :allow-empty="false"
                                            :show-labels="false"
                                            label="nameRu"
                                            name="districtName"
                                            id="districtId"
                                            @input="
                                                handleFromEditDistrictSelect
                                            "
                                            :disabled="!canSaveOrAdd()"
                                        />
                                    </div>
                                </b-input-group>
                            </template>
                            <template v-else-if="info.head === 'СНП'">
                                <label class="mr-sm-2"
                                    ><span
                                        :class="{
                                            required: isRequired(info.head),
                                        }"
                                        >{{ info.head }}</span
                                    ></label
                                >
                                <div>
                                    <multiselect
                                        v-model="editSnpVal"
                                        :options="
                                            createSnpArr.filter(
                                                (item) => item.nameRu !== 'Все'
                                            )
                                        "
                                        placeholder="Выберите СНП"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        :id="`item_field_${info.column_number}`"
                                        :name="`item_field_${info.column_number}`"
                                        label="nameRu"
                                        :disabled="!canSaveOrAdd()"
                                    />
                                </div>
                            </template>
                            <template
                                v-else-if="
                                    info.head !== 'Область' &&
                                    info.head !== 'КАТО'
                                "
                            >
                                <label class="mr-sm-2"
                                    ><span
                                        :class="{
                                            required: isRequired(info.head),
                                        }"
                                        >{{ info.head }}</span
                                    ></label
                                >
                                <!-- <b-form-input v-if="info.head === 'Район'" disabled class="mr-sm-8" size="lg" type="text"
                                                v-model="info.value"/> -->
                                <template
                                    v-if="
                                        info.params &&
                                        !info.params.editable &&
                                        !info.isList
                                    "
                                >
                                    <div class="px-2">
                                        {{ info.value }}
                                    </div>
                                </template>
                                <template
                                    v-else-if="info.params && info.isList"
                                >
                                    <div>
                                        <multiselect
                                            v-model="info.value"
                                            :options="
                                                info.params.values.map(
                                                    (item) => ({ value: item })
                                                )
                                            "
                                            :placeholder="info.head"
                                            :allow-empty="false"
                                            :show-labels="false"
                                            :id="`item_field_${info.column_number}`"
                                            :name="`item_field_${info.column_number}`"
                                            label="value"
                                            :disabled="!canSaveOrAdd()"
                                            :multiple="
                                                info.params.multiple_choice
                                            "
                                            :close-on-select="
                                                !info.params.multiple_choice
                                            "
                                            track-by="value"
                                            style="max-width: 290px"
                                        >
                                            <template
                                                slot="selection"
                                                slot-scope="{ values, isOpen }"
                                                ><span
                                                    class="multiselect__single"
                                                    v-if="
                                                        info.params
                                                            .multiple_choice &&
                                                        values.length
                                                    "
                                                    v-show="!isOpen"
                                                    >{{
                                                        values
                                                            .map(
                                                                (item) =>
                                                                    item.value
                                                            )
                                                            .join(", ")
                                                    }}
                                                </span></template
                                            >
                                        </multiselect>
                                    </div>
                                </template>
                                <template v-else>
                                    <b-form-input
                                        v-if="!isSchoolEdit"
                                        class="mr-sm-8"
                                        size="lg"
                                        :type="
                                            info.params &&
                                            info.params.data_type &&
                                            (info.params.data_type ===
                                                'integer' ||
                                                info.params.data_type ===
                                                    'float')
                                                ? 'number'
                                                : 'text'
                                        "
                                        :id="`item_field_${info.column_number}`"
                                        :name="`item_field_${info.column_number}`"
                                        v-model="info.value"
                                        :disabled="!canSaveOrAdd()"
                                        @input="handleChangeValue(info, index)"
                                        :class="
                                            info.params &&
                                            controlMap[index] &&
                                            'control-error'
                                        "
                                        @keypress="
                                            (e) =>
                                                info.params &&
                                                info.params.data_type &&
                                                info.params.data_type ===
                                                    'integer' &&
                                                (e.key === '.' ||
                                                    e.key === '-') &&
                                                e.preventDefault()
                                        "
                                        @mousewheel="(e) => e.preventDefault()"
                                    />
                                    <b-form-input
                                        v-else
                                        class="mr-sm-8"
                                        size="lg"
                                        :type="
                                            info.params &&
                                            info.params.data_type &&
                                            info.params.data_type === 'string'
                                                ? 'text'
                                                : 'number'
                                        "
                                        :id="`item_field_${info.column_number}`"
                                        :name="`item_field_${info.column_number}`"
                                        v-model="info.value"
                                        :disabled="!canSaveOrAdd()"
                                        @input="handleChangeValue(info, index)"
                                        :class="
                                            info.params &&
                                            controlMap[index] &&
                                            'control-error'
                                        "
                                        @keypress="
                                            (e) =>
                                                info.params &&
                                                info.params.data_type &&
                                                info.params.data_type ===
                                                    'integer' &&
                                                (e.key === '.' ||
                                                    e.key === '-') &&
                                                e.preventDefault()
                                        "
                                        @mousewheel="(e) => e.preventDefault()"
                                    />
                                </template>
                            </template>
                        </b-input-group>
                    </template>
                </b-form>
            </template>
            <template #modal-footer style="justify-content: left">
                <template
                    v-if="
                        (isSchoolsSelectedRegistry && roles.VILLAGE) ||
                        (isRoadsSelectedRegistry &&
                            roles.DISTRICT_DEPARTMENTS)
                    "
                >
                    <b-button
                        variant="danger"
                        class="float-left"
                        @click="openDeleteModal"
                        >Удалить</b-button
                    >
                    <b-button
                        variant="primary"
                        class="float-left"
                        @click="editRegistry"
                        >Сохранить</b-button
                    >
                    <b-button variant="light" @click="editModalVisible = false"
                        >Отменить</b-button
                    >
                </template>
            </template>
        </b-modal>

        <b-modal
            id="registry-field"
            class="myModalProject"
            v-model="modalRegistryVisible"
            size="lg"
            centered
            content-class="modal-forms"
            hide-footer
            body-class="registry-field"
        >
            <template #modal-title>
                Выберите показатель:
                <div style="padding: 7px 0px">
                    <!-- @blur="searchHeaderText(searchHeader)" -->
                    <b-form-input
                        type="search"
                        size="lg"
                        v-model="searchHeader"
                        placeholder="Поиск"
                        class="mw-100"
                    >
                        <i class="icon icon-search"></i>
                    </b-form-input>
                </div>
            </template>
            <template v-for="(item, inx) of searchReportHeadersArr">
                <div :key="inx">
                    <ul class="list-group list-group-">
                        <li
                            class="list-group-item"
                            v-if="
                                item.visible === true &&
                                item.description !== 'КАТО'
                            "
                            @click="handleHeaderClick(item)"
                        >
                            {{ item.description }}
                        </li>
                    </ul>
                </div>
            </template>
        </b-modal>
        <b-modal
            id="save-template-form"
            v-model="saveTemplateModalVisible"
            size="sm"
            centered
            title="Введите название шаблона"
            hide-footer
            hide-header
        >
            <b-form class="save-template-form">
                <b-form-group
                    label="Введите название шаблона"
                    label-for="template-name-input"
                >
                    <b-form-input
                        size="sm"
                        id="theme"
                        v-model="templateName"
                    ></b-form-input>
                </b-form-group>
                <b-button-group>
                    <b-button variant="success" @click="saveTemplate"
                        >Сохранить</b-button
                    >
                    <b-button
                        variant="light"
                        @click="saveTemplateModalVisible = false"
                        >Отменить</b-button
                    >
                </b-button-group>
            </b-form>
        </b-modal>

        <b-modal
            id="delete-registry"
            v-model="deleteModalVisible"
            size="sm"
            centered
            hide-footer
            hide-header
            title="Все данные и объект удалятся безвозвратно, вы уверены?"
        >
            <div class="delete-modal">
                <p>Все данные и объект удалятся безвозвратно, вы уверены?</p>
                <b-button variant="danger" @click="deleteRegistry"
                    >Удалить</b-button
                >
                <b-button variant="light" @click="deleteModalVisible = false"
                    >Отменить</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { MonitoringSnpApi } from "./api/MonitoringSnpApi";
import { isEmpty } from "lodash";
import moment from "moment";
import { Ax } from "@/utils";
import {
    IN_PROCESS,
    SEND_TO_APPROVE,
    SEND_TO_REPROCESS,
    APPROVED,
    RECONCILED_BY_DEPARTMENTS,
    RECONCILED,
    APPROVED_BY_DEPARTMENTS,
    ROLE_VILLAGE,
    ROLE_REGION_DEPARTMENTS,
    ROLE_DISTRICT_DEPARTMENTS,
    ROLE_DISTRICT,
    ROLE_REGION,
    APPROVED_BY_ADDITIONAL_DEPARTMENTS,
} from "@/modules/monitoring-snp/consts/statuses";
import F from "../ymap/astanamap.vue";

export default {
    name: "Registry",
    props: [
        "me",
        "regions",
        "reportTypes",
        "registryArr",
        "yearsArr",
        "fromPassport",
    ],
    data() {
        return {
            secretKey:
                "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkZXZlbG9wZXIiOiJTYWdhc2ggQXJneW4ifQ.4ejj9_Ce45z0AEUyFrpZS2QjIvVV96899UTyLM8Icro",
            templateVal: null,
            createModalVisible: false,
            saveTemplateModalVisible: false,
            editModalVisible: false,
            templateName: null,
            templateArr: [],
            yearVal: this.yearsArr[this.yearsArr.length - 1],
            registryVal: {
                id: 12,
                name: "Реестр школ",
            },
            roles: {
                VILLAGE: this.checkRole(ROLE_VILLAGE),
                DISTRICT_DEPARTMENTS:
                    this.checkRole(ROLE_DISTRICT_DEPARTMENTS) ||
                    this.checkRole("ROLE_usersnp_district_departments"),
                DISTRICT: this.checkRole(ROLE_DISTRICT),
                REGION_DEPARTMENTS:
                    this.checkRole(ROLE_REGION_DEPARTMENTS) ||
                    this.checkRole("ROLE_usersnp_region_departments"),
                REGION: this.checkRole(ROLE_REGION),
                ADMIN: this.checkRole("ROLE_SNP_ADMIN"),
            },
            statusColors: {
                SEND_TO_APPROVE: "#F79647",
                RECONCILED: "#2196F3",
                APPROVED: "#01AC50",
                SEND_TO_REPROCESS: "#C0504C",
                IN_PROCESS: "#6087A0",
            },
            registryChange: [],
            regionVal: null,
            regionArr: [],
            snpVal: null,
            snpArr: [],
            districtVal: null,
            districtArr: [],
            sgpDoc: [
                {
                    name_ru: "Шаблон",
                    name_kk: "Шаблон",
                    name_en: "Template",
                },
                {
                    name_ru: "Реестр",
                    name_kk: "Реест",
                    name_en: "Registry",
                },
                {
                    name_ru: "Район",
                    name_kk: "Райой",
                    name_en: "District",
                },
                {
                    name_ru: "Сельский округ",
                    name_kk: "Сельский округ",
                    name_en: "Rural district",
                },
                {
                    name_ru: "СНП",
                    name_kk: "СНП",
                    name_en: "SNP",
                },
                {
                    name_ru: "Год",
                    name_kk: "Жыл",
                    name_en: "Year",
                },
            ],
            infoArr: [],
            infoRegistryArr: [],
            accidentRateArr: ["Да", "Нет"],
            formInfo: [
                {
                    head: "Наименование объекта",
                    value: "",
                    column_number: 4,
                    isField: false,
                },
                {
                    head: "СНП",
                    value: {
                        code: 556067100,
                        codePotenSnp: "1",
                        codeSnp: "2",
                        dateBegin: "1990-01-01",
                        dateEnd: null,
                        id: 11691,
                        nameKz: "Новочерноярка а.",
                        nameRu: "с.новочерноярка",
                        parentId: 11690,
                        type: 3,
                        typeOfSettlement: 2,
                    },
                    column_number: 5,
                    isField: false,
                },
                {
                    head: "Год последнего капитального ремонта",
                    value: "",
                    column_number: 7,
                    isField: true,
                },
                {
                    head: "Процент износа здания",
                    value: "",
                    column_number: 8,
                    isField: true,
                },
                {
                    head: "Кол-во мест",
                    value: "",
                    column_number: 9,
                    isField: true,
                },
                {
                    head: "Кол-во обучающихся детей",
                    value: "",
                    column_number: 10,
                    isField: true,
                },
                {
                    head: "Состояние аварийности (Да/Нет)",
                    value: "",
                    column_number: 11,
                    isField: true,
                },
                {
                    head: "в 1-ой смене",
                    value: "",
                    column_number: 12,
                    isField: true,
                },
                {
                    head: "в 2-ой смене",
                    value: "",
                    column_number: 13,
                    isField: true,
                },
            ],
            globalArr: [],
            selectedRate: false,
            formFieldArr: [],
            registryTypeArr: [],
            modalRegistryVisible: false,
            reportHeadersArr: [],
            searchReportHeadersArr: [],
            searchHeader: "",
            selectedType: null,
            selectedHeaderIndx: null,
            currentHeads: [],
            loading: false,
            sections: [],
            katoCodeValue: null,
            selectRegistryName: null,
            selectedSchool: {},
            newItem: {},
            createRegionVal: null,
            createSnpArr: [],
            createSnpVal: null,
            createDistrictArr: [],
            createDistrictVal: null,
            modalSnpArr: [],
            modalSnpVal: null,
            isDisabled: false,
            selectedTemplateHeader: [],
            formRegistry: {},
            currentYear: new Date().getFullYear(),
            isSchoolEdit: false,
            notVisible: ["КАТО"],
            isShowCreateBtn: false,
            isAfterSelectedTemp: false,
            localRoads: null,
            selectedSnpLabel: this.me.initialSnp.nameRu,
            selectedRegionLabel: "",
            editDistrictVal: null,
            editDistrictArr: [],
            editRegionVal: null,
            editSnpVal: null,
            tempDistrict: [],
            regionsKatoCodes: [],
            reconciliation: {},
            controlMap: [],
            progress: 0,
            notificationArray: [],
            deleteModalVisible: false,
            selectedRegistry: { id: "12", formCode: "F012", name: "Реестр школ" },
            historyLoading: false,
            historyData: [],
            hierarchy: null,
            schoolRequiredFields: [
                "ID",
                "Школа",
                "Район",
                "Сельский округ",
                "СНП",
                "Год последнего капитального ремонта",
                "Процент износа здания",
                "Состояние аварийности (да/нет)",
                "типовая, приспособленная",
                "Количество мест",
                "Количество обучающихся детей",
                "Год постройки здания",
                "Тип организации образования",
            ],
            roadRequiredFields: [
                "Район",
                "Значение дороги",
                "Индекс автодороги",
                "Наименование автодороги",
                "Асфальтобетонное покрытие",
                "Черное покрытие",
                "Гравийно-щебеночное покрытие",
                "Грунтовое покрытие",
                "Состояние хорошее, км",
                "Состояние удовлетворительное, км",
                "Состояние неудовлетворительное, км",
                "Проведенные ремонтные работы",
                "Протяженность проведенных работ, км",
                "Протяженность дороги, где требуется капитальный ремонт",
                "Протяженность дороги, где требуется средний ремонт",
            ],
        };
    },
    computed: {
        // после перехода на /form/metadata id элемента фильтра — это id формы,
        // а не 12/13, поэтому тип реестра определяем по formCode
        isRoadsRegistry() {
            const formCode = this.registryVal?.formCode;
            return (
                formCode === "F006" ||
                formCode === "F013" ||
                +this.registryVal?.id === 13
            );
        },
        // selectedRegistry — это применённый реестр (registryVal — только выбор
        // в панели фильтра). Реестров два, поэтому «не дороги» = школы
        isRoadsSelectedRegistry() {
            const formCode = this.selectedRegistry?.formCode;
            return (
                formCode === "F006" ||
                formCode === "F013" ||
                +this.selectedRegistry?.id === 13
            );
        },
        isSchoolsSelectedRegistry() {
            return !this.isRoadsSelectedRegistry;
        },
        defaultYear() {
            return Array.isArray(this.yearsArr) && this.yearsArr.length
                ? this.yearsArr[this.yearsArr.length - 1]
                : null;
        },
    },
    watch: {
        // yearsArr приходит пропом асинхронно (/admin/years), а yearVal
        // инициализируется в data() — без этого вотчера год остаётся undefined,
        // и yearGroups[String(undefined)] даёт пустой реестр без ошибки
        yearsArr: {
            immediate: true,
            handler(years) {
                if (!Array.isArray(years) || !years.length) {
                    return;
                }
                const hadYear =
                    this.yearVal !== null && this.yearVal !== undefined;
                if (!hadYear || !years.includes(this.yearVal)) {
                    this.yearVal = years[years.length - 1];
                }
                // годы пришли после mounted(): сверка там пропущена без года — запрашиваем её сейчас
                if (!hadYear) {
                    this.getReconciliation();
                }
            },
        },
        localRoads: function (newName) {
            this.getInfoLocalStorage(newName);
        },
        fromPassport: function () {
            this.regionVal = this.fromPassport.selectedRegion;
            this.registryVal = this.fromPassport.selectedReportType;
            this.snpVal = this.fromPassport.selectedSnp;
            this.getSnpData(this.isTemplate);
        },
        searchHeader: function () {
            this.searchHeaderText(this.searchHeader);
        },
    },
    mounted() {
        this.loadTemplates();
        this.getInitialSnpData();
        this.getReconciliation();
        this.regionsKatoCodes = this.me?.katoCodes?.filter(
            (item) => item[4] === "0" && item[5] === "0"
        );
    },
    methods: {
        getInfoLocalStorage(localRoads) {
            if (!isEmpty(localRoads)) {
                this.registryVal.id = 13;
                this.registryVal.formCode = "F013";
                this.registryVal.name = "Реестр дорог";
                this.regionVal = localRoads.selectedRegion;
                this.districtVal = this.snpVal = null;
                this.applyFilter();
            }
        },
        getKatoInfoByCode(code) {
            MonitoringSnpApi.get(`/snp/api/v1/admin/address?code=${code}`)
                .then((res) => {
                    if (res.status === 200) {
                        if (this.districtArr.length === 0) {
                            const region = this.regions.find(
                                (item) => item.nameRu === res.data.region
                            );
                            this.getKatoChildren(region?.id)
                                .then((res) => {
                                    this.editDistrictArr = res.data;
                                    this.editDistrictVal = res.data.find(
                                        (item) =>
                                            item.nameRu === res.data.district
                                    );
                                })
                                .catch((err) => console.log(err));
                        } else {
                            this.editDistrictVal = this.districtArr.find(
                                (item) => item.nameRu === res.data.district
                            );
                        }

                        this.editDistrictVal &&
                            this.loadAllSnp(this.editDistrictVal.code);
                    }
                })
                .catch((err) => {
                    console.log("err", err);
                    ("Ошибка");
                });
        },
        handleTemplateSelect() {
            this.regionVal = null;
            this.districtVal = null;
            this.snpVal = null;
        },
        handleRegistrySelect() {
            if (this.registryVal !== null) {
                this.templateVal = null;
                this.formRegistry = [];
                // заголовки зависят от реестра — сбрасываем, чтобы они
                // перезаполнились из ответа выбранного реестра
                this.reportHeadersArr = [];
                this.searchReportHeadersArr = [];
                this.getRegistryForm();
            }
        },
        // отдельного эндпоинта со справочником показателей в новом API нет
        // (см. закомментированный вызов выше), поэтому берём их из первого
        // загруженного объекта реестра — иначе карточка объекта пустая
        syncRegistryHeaders() {
            if (this.reportHeadersArr.length) {
                return;
            }
            const fields = this.infoRegistryArr?.[0]?.fields;
            if (!Array.isArray(fields) || !fields.length) {
                return;
            }
            this.reportHeadersArr = fields;
            this.searchReportHeadersArr = fields;
            this.getRegistryForm();
        },
        searchHeaderText(searchText) {
            if (!isEmpty(searchText)) {
                const arrFilter = this.reportHeadersArr;
                const item = arrFilter.filter((item) =>
                    item.description
                        .toLowerCase()
                        .includes(searchText.toLowerCase())
                );
                this.searchReportHeadersArr = item;
            } else {
                this.searchReportHeadersArr = this.reportHeadersArr;
            }
        },
        handleRegionSelect() {
            this.templateVal = null;
            this.districtVal = null;
            this.snpVal = null;
            if (this.regionVal?.nameRu === "Все") {
                this.districtArr = [];
                this.snpArr = [];
            } else {
                this.regionVal?.code && this.loadDistricts();
            }
        },
        handleDistrictSelect() {
            this.templateVal = null;
            this.snpVal = null;
            if (this.districtVal?.nameRu === "Все") {
                this.snpArr = [];
            }
            this.districtVal?.code && this.loadSnp();
        },
        handleSnpSelect() {
            this.setSelectedSnpLabel();
        },
        setSelectedSnpLabel() {
            // подпись в шапке: район / сельский округ / СНП — из того, что выбрано в фильтре
            this.selectedSnpLabel = [
                this.regionVal?.nameRu,
                this.districtVal?.nameRu,
                this.snpVal?.nameRu,
            ]
                .filter(Boolean)
                .join(" / ");
        },
        setSelectedRegionLabel() {
            this.selectedRegionLabel = this.regionVal?.nameRu ?? "";
        },
        checkRole(role) {
            if (this.me?.roles) {
                return this.me.roles.find((r) =>
                    r.toLocaleLowerCase().startsWith(role.toLocaleLowerCase())
                );
            }
            return false;
        },
        checkKato() {
            return this.me.katoCodes.includes(this.snpVal?.code.toString());
        },
        checkRoleByCode(code) {
            return this.me.katoCodes.includes(code.toString());
        },
        checkEditAvailable(role) {
            if (this.snpVal?.nameRu === "Все") {
                return false;
            } else {
                return (
                    this.checkRole(role) &&
                    this.me.katoCodes.includes(this.snpVal?.code.toString())
                );
            }
        },
        handleUpdateRegistry(value, label) {
            this.updateRegistry(value, value.fields[label].value, label);
        },
        handleFromRegionSelect() {
            this.loadTempDistricts();
            this.createRegionVal && this.loadAllSnp(this.createRegionVal.code);
            this.editRegionVal && this.loadAllSnp(this.editRegionVal.code);
            this.createDistrictVal = null;
            this.editDistrictVal = null;
        },
        handleFromDistrictSelect() {
            this.createDistrictVal &&
                this.loadAllSnp(this.createDistrictVal.code);
        },
        handleFromEditDistrictSelect() {
            this.editSnpVal = null;
            this.editDistrictVal && this.loadAllSnp(this.editDistrictVal.code);
        },
        handleSaveTemplate() {
            if (this.currentHeads.length !== 5) {
                this.makeToast(
                    "danger",
                    "Вы не выбрали все заголовки таблицы",
                    "Ошибка!!!"
                );
                return;
            }
            this.saveTemplateModalVisible = true;
        },
        //  this.reportHeadersArr = res.data; headers here
        //  this.searchReportHeadersArr = res.data;
        //  this.formRegistry = res.data;
        loadTemplateRegistry() {
            this.regionVal = this.districtVal = this.snpVal = null;
            this.isTemplate = true;
            const selectedTemplateInit = this.templateArr.find(
                (template) => template.name === this.templateVal
            );
            this.tempRegions = selectedTemplateInit.sections[0].first.values;
            if (this.tempRegions === null) {
                this.makeToast(
                    "danger",
                    "Пользователь не прикрпелен к региону",
                    "Ошибка"
                );
                return;
            }

            this.globalArr = [];
            this.currentHeads = [];
            this.yearHeads = [];

            this.tempRegions.forEach((item, index) => {
                const obj = {
                    idx: index,
                    code: item.address.code,
                    name: item.additional_index,
                    snp: item.address.snp,
                    isEdit: false,
                    fields: [],
                };
                this.globalArr.push({ ...obj });
            });

            selectedTemplateInit.sections.forEach((item, sectionIndex) => {
                this.currentHeads[sectionIndex] = {
                    idx: sectionIndex,
                    desc: item.head,
                };

                item.first.values.forEach((valItem, valIndex) => {
                    this.globalArr[valIndex].fields.push({ ...valItem });
                });
            });
        },
        // Дочерние элементы КАТО. У пункта «Все» и невыбранного фильтра id нет —
        // без parentId бэкенд отвечает 400, поэтому сразу отдаём пустой список
        getKatoChildren(parentId) {
            if (parentId === null || parentId === undefined || parentId === "") {
                return Promise.resolve({ data: [] });
            }
            return MonitoringSnpApi.get("/snp/api/v1/admin/dict-kato", {
                parentId,
            });
        },
        loadDistricts() {
            try {
                this.getKatoChildren(this.regionVal?.id)
                    .then((res) => {
                        this.districtArr = [{ nameRu: "Все" }, ...res.data];
                        this.createDistrictArr = res.data;
                        this.editDistrictArr = res.data;
                    })
                    .catch((err) => console.log(err));
            } catch (error) {
                console.log(error);
            }
        },
        loadTempDistricts() {
            const code = this.createModalVisible
                ? this.createRegionVal.id
                : this.editRegionVal.id;

            try {
                this.getKatoChildren(code)
                    .then((res) => {
                        this.createDistrictArr = res.data;
                        this.editDistrictArr = res.data;
                    })
                    .catch((err) => console.log(err));
            } catch (error) {
                console.log(error);
            }
        },
        loadSnp() {
            try {
                this.getKatoChildren(this.districtVal?.id)
                    .then((res) => {
                        this.snpArr = [{ nameRu: "Все" }, ...res.data];
                        this.createSnpArr = res.data;
                    })
                    .catch((err) => console.log(err));
            } catch (error) {
                console.log(error);
            }
        },
        getChildValueByParentId(parentId) {
            this.getKatoChildren(parentId)
                .then((res) => {
                    this.tempDistrict = res.data;
                })
                .catch((err) => console.log(err));
        },
        getCode() {
            const code = {};
            if (this.snpVal?.code) {
                code.katoCode = this.snpVal.code;
            } else if (this.districtVal?.code) {
                code.katoCode = this.districtVal.code;
            } else if (this.regionVal?.code) {
                code.katoCode = this.regionVal.code;
            }

            if (this.isRoadsRegistry && this.regionVal) {
                code.katoCode = this.regionVal.code;
            }

            return code;
        },
        loadAllSnp(codeKato) {
            try {
                MonitoringSnpApi.get(
                    `/snp/api/v1/admin/all-snp?code=${codeKato}`
                )
                    .then((res) => {
                        this.modalSnpArr = res.data;
                        this.createSnpArr = res.data;
                        if (this.snpVal && this.snpVal.nameRu !== "Все") {
                            this.createSnpVal = this.snpVal;
                        } else if (
                            this.snpVal &&
                            this.snpVal.nameRu === "Все"
                        ) {
                            this.createSnpVal = res.data[0];
                        } else {
                            this.createSnpVal = res.data.find(
                                (item) =>
                                    item.nameRu === this.me.initialSnp.snpNameRu
                            );
                        }
                        if (this.selectedSchool)
                            this.editSnpVal = this.createSnpArr.find(
                                (item) =>
                                    item.nameRu ===
                                    this.selectedSchool.address_name
                            );
                    })
                    .catch((err) => console.log(err));
            } catch (error) {
                console.log(error);
            }
        },
        closeFilterPanel() {
            this.$refs.drop.hide();
        },
        downloadFile() {
            let url;
            let code;
            if (this.snpVal?.code) {
                code = this.snpVal.code;
                url = `/snp/api/v1/report/file/registry?code=${this.snpVal.code}&registryId=${this.registryVal.id}&year=${this.yearVal}`;
            } else if (this.districtVal?.code) {
                code = this.districtVal.code;
                url = `/snp/api/v1/report/file/registry?code=${this.districtVal.code}&registryId=${this.registryVal.id}&year=${this.yearVal}`;
            } else if (this.regionVal?.code) {
                code = this.regionVal.code;
                url = `/snp/api/v1/report/file/registry?code=${this.regionVal.code}&registryId=${this.registryVal.id}&year=${this.yearVal}`;
            }

            Ax(
                {
                    url,
                    method: "GET",
                    data: null,
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.token}`,
                    },
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        `${code}-${this.registryVal.id}-${this.yearVal}.xlsx`
                    );
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    console.log("err", error);
                }
            );
        },
        applyFilter() {
            this.isAfterSelectedTemp = false;
            if (
                this.templateVal === null &&
                this.regionVal !== null &&
                this.districtVal !== null &&
                this.snpVal === null
            ) {
                if (this.districtVal.nameRu !== "Все") {
                    this.makeToast("danger", "Вы не выбрали СНП", "Ошибка");
                    return false;
                }
            }
            if (this.templateVal !== null) {
                this.isAfterSelectedTemp = true;
                this.templateVal && this.loadTemplateRegistry();
                this.closeFilterPanel();
                return;
            } else {
                if (this.templateVal === null) {
                    if (this.registryVal === null) {
                        alert("Вы не выбрали Реестр");
                        return;
                    }
                }
                if (
                    this.regionVal !== null &&
                    this.districtVal === null &&
                    !this.isRoadsRegistry
                ) {
                    if (this.regionVal.nameRu !== "Все") {
                        this.makeToast(
                            "danger",
                            "Вы не выбрали Сельский округ",
                            "Ошибка"
                        );
                        return false;
                    }
                }
                if (
                    this.regionVal !== null ||
                    this.districtVal !== null ||
                    this.snpVal !== null
                ) {
                    this.isTemplate = false;
                }
                this.getHierarchy();
                this.getSnpData(this.isTemplate);
            }
            this.currentHeads = [];
            this.selectedRegistry = this.registryVal;
            this.getReconciliation();
            this.closeFilterPanel();
            if (this.isRoadsRegistry) {
                this.selectedSnpLabel = null;
                this.setSelectedRegionLabel();
            } else {
                this.selectedRegionLabel = null;
                this.setSelectedSnpLabel();
            }
        },
        resetFilter() {
            this.templateVal =
                this.regionVal =
                this.districtVal =
                this.snpVal =
                this.registryVal =
                    null;
            // год не обнуляем: без него yearGroups не находится и реестр пустой
            this.yearVal = this.defaultYear;
            // this.districtVal = this.snpArr = this.globalArr = [];
            // this.closeFilterPanel();
            // this.currentHeads = [];
        },
        reloadData() {
            this.globalArr = [];
            this.currentHeads = [];
            this.loadSnpData();
        },
        loadTemplateHeader(res, selHead) {
            selHead.forEach((item, index) => {
                const filteredHead = res.filter((data) => {
                    return (
                        data.description === item.desc &&
                        data.type === item.type
                    );
                })[0];
                const selectedHead = {
                    idx: index,
                    id: filteredHead.id,
                    desc: filteredHead.description,
                    type: filteredHead.type,
                    column_number: filteredHead.column_number,
                    parentId: filteredHead.parentId,
                };

                this.currentHeads[index] = selectedHead;
                const sectionItem = {
                    head: filteredHead.description,
                    first: {},
                    second: {},
                };
                this.sections[selectedHead.idx] = sectionItem;
            });
        },
        defaultHeader(res) {
            const isRoads = this.isRoadsRegistry;
            const defaultHeaders = res.filter((item) => {
                if (isRoads) {
                    return (
                        (item.columnNumber >= 7 && item.columnNumber <= 10) ||
                        item.columnNumber === 19
                    );
                }
                return item.columnNumber >= 8 && item.columnNumber <= 12;
            });
            defaultHeaders.forEach((item, index) => {
                const selectedHead = {
                    idx: index,
                    id: item.id,
                    desc: item.description,
                    type: item.type,
                    columnNumber: item.columnNumber,
                    parentId: item.parentId,
                };
                this.currentHeads[index] = selectedHead;
                const sectionItem = {
                    head: item.description,
                    first: {},
                    second: {},
                };
                this.sections[selectedHead.idx] = sectionItem;
            });
        },
        loadSnpData() {
            this.districtMap = {};
            const code = {};
            const selectedVal = {};
            if (this.snpVal?.code) {
                code.katoCode = this.snpVal.code;
                selectedVal.id = this.snpVal.id;
                this.katoCodeValue = this.snpVal.code;
            } else if (this.districtVal?.code) {
                code.katoCode = this.districtVal.code;
                selectedVal.id = this.districtVal.id;
                this.katoCodeValue = this.districtVal.code;
            } else if (this.regionVal?.code) {
                code.katoCode = this.regionVal.code;
                selectedVal.id = this.regionVal.id;
                this.katoCodeValue = this.regionVal.code;
            }
            this.loading = true;
            selectedVal.id &&
                MonitoringSnpApi.get("/snp/api/v1/admin/dict-kato", {
                    parentId: selectedVal.id,
                })
                    .then((res) => {
                        this.infoArr = res.data;
                        this.infoArr.forEach((item) => {
                            if (!this.districtMap.hasOwnProperty(item.nameRu)) {
                                const obj = {
                                    id: item.id,
                                    code: item.code,
                                    name: 'КГУ "СОШ имени Мухтара Ауезова"',
                                    snp: item.nameRu,
                                    fields: {},
                                };
                                this.districtMap[item.id] = obj;
                                this.globalArr.push({ ...obj });
                            }
                        });
                    })
                    .catch((err) => console.log(err))
                    .finally(() => (this.loading = false));
        },
        reportTypeModal(columnIdx) {
            this.selectedHeaderIndx = columnIdx;
            this.modalRegistryVisible = true;
        },
        handleHeaderClick(header) {
            const selectedHead = {
                idx: this.selectedHeaderIndx,
                id: header.id,
                desc: header.description,
                type: header.type,
                columnNumber: header.columnNumber,
                parentId: header.parentId,
            };
            this.currentHeads[this.selectedHeaderIndx] = selectedHead;
            const sectionItem = {
                head: header.description,
                first: {},
                second: {},
            };
            this.sections[selectedHead.idx] = sectionItem;
            this.modalRegistryVisible = false;
            this.initSectionValue(this.katoCodeValue);
        },
        getInitialSnpData() {
            const code = {};
            // коды в справочнике — числа, в me.initialSnp — строки: сравниваем как строки
            this.regionVal = this.regions.find(
                (reg) =>
                    String(reg.code) ===
                    String(this.me.initialSnp.regionKatoCode)
            );
            code.katoCode = this.me.katoCodes[this.me.katoCodes.length - 1];
            this.katoCodeValue =
                this.me.katoCodes[this.me.katoCodes.length - 1];
            this.districtMap = {};

            const kato = this.me.initialSnp.katoCode || code.katoCode;
            this.globalArr = [];
            MonitoringSnpApi.get(`/snp/api/v1/form/registry/F012/${kato}`, {
                year: this.yearVal,
            })
                .then((res) => {
                    if (res.status === 200) {
                        this.infoRegistryArr = this.transformRegistryResponse(
                            res.data?.data
                        );

                        this.syncRegistryHeaders();
                        this.infoRegistryArr.forEach((item) => {
                            if (!this.districtMap.hasOwnProperty(item.id)) {
                                this.districtMap[item.id] = item;
                                this.globalArr.push({ ...item });
                                if (Array.isArray(item.fields)) {
                                    this.defaultHeader(item.fields);
                                }
                                this.initSectionValue();
                            }
                        });

                        this.getHierarchy();

                        // у областного пользователя район не выбран (найден пункт «Все»
                        // или ничего) — округа и СНП не грузим, как в handleRegionSelect
                        if (
                            !this.regionVal?.id ||
                            this.regionVal.nameRu === "Все"
                        ) {
                            this.districtArr = [];
                            this.snpArr = [];
                            return;
                        }
                        this.getKatoChildren(this.regionVal.id)
                            .then((res) => {
                                this.districtArr = [
                                    { nameRu: "Все" },
                                    ...res.data,
                                ];
                                this.createDistrictArr = res.data;
                                this.editDistrictArr = res.data;
                                this.districtVal = this.districtArr.find(
                                    (dist) =>
                                        String(dist.code) ===
                                        String(
                                            this.me.initialSnp.districtKatoCode
                                        )
                                );
                                this.createDistrictVal = this.districtVal;
                                if (!this.districtVal?.id) {
                                    this.snpArr = [];
                                    return;
                                }
                                MonitoringSnpApi.get(
                                    "/snp/api/v1/admin/dict-kato",
                                    { parentId: this.districtVal.id }
                                )
                                    .then((res) => {
                                        this.snpArr = [
                                            { nameRu: "Все" },
                                            ...res.data,
                                        ];
                                        this.snpVal = res.data.find(
                                            (dist) =>
                                                String(dist.code) ===
                                                String(
                                                    this.me.initialSnp.katoCode
                                                )
                                        );
                                        this.setSelectedSnpLabel();
                                    })
                                    .catch(() => {});
                            })
                            .catch((err) => console.log(err));
                    }
                })
                .catch((err) => {
                    console.log("err", err);
                })
                .finally(() => (this.loading = false));
        },
        getSnpData(isTemplate = false) {
            this.loading = true;
            this.districtMap = {};
            this.globalArr = [];
            const { katoCode } = this.getCode();

            const formCode = this.registryVal.formCode || "F012";
            MonitoringSnpApi.get(
                `/snp/api/v1/form/registry/${formCode}/${katoCode}`,
                { year: this.yearVal }
            )
                .then((res) => {
                    if (res.status === 200) {
                        this.infoRegistryArr = this.transformRegistryResponse(
                            res.data?.data
                        );
                        this.syncRegistryHeaders();
                        this.infoRegistryArr.forEach((item) => {
                            if (!this.districtMap.hasOwnProperty(item.id)) {
                                this.districtMap[item.id] = item;
                                this.globalArr.push({ ...item });
                                if (!isTemplate) {
                                    if (Array.isArray(item.fields)) {
                                        this.defaultHeader(item.fields);
                                    }
                                } else {
                                    if (Array.isArray(item.fields)) {
                                        this.loadTemplateHeader(
                                            item.fields,
                                            this.selectedTemplateHeader
                                        );
                                    }
                                }
                                this.initSectionValue();
                            }
                        });
                        this.getHierarchy();
                    }
                })
                .catch((err) => {
                    console.log("err", err);
                })
                .finally(() => (this.loading = false));
        },
        initSectionValue() {
            this.katoData = {};
            this.globalArr?.forEach((item) => {
                this.katoData = this.infoRegistryArr.find(
                    (infoItem) => item.id === infoItem.id
                );
                if (!isEmpty(this.katoData)) {
                    this.tempFields = [];
                    this.currentHeads?.forEach((head, headIndex) => {
                        const fieldInfo = this.katoData.fields.find(
                            (findItem) => findItem.head === head.desc
                        );
                        if (fieldInfo != undefined) {
                            const newField = {
                                idx: headIndex,
                                columnNumber: fieldInfo.column_number,
                                editable: fieldInfo.editable,
                                head: fieldInfo.head,
                                params: fieldInfo.params,
                                value: fieldInfo.value,
                            };
                            this.tempFields[headIndex] = newField;
                        }
                    });
                    item.fields = this.tempFields;
                }
            });
        },
        modalUpdateRegistry(item, val, itemId) {
            //this.updateRegistry(item, val, itemId)
            const formInfo = {
                id: item.id,
                code: parseInt(item.code),
                name: item.name,
                type: item.type,
                year: item.year,
                address_name: item.snp,
                additional_index: item.additional_index,
                fields: [
                    {
                        value: val.toString(),
                        editable: item.editable,
                        params: item.params,
                        head: item.head,
                        column_number: item.columnNumber,
                    },
                ],
            };
            const body = [
                {
                    value: val.toString(),
                    editable: item.editable,
                    params: item.params,
                    head: item.head,
                    column_number: item.column_number,
                },
            ];
        },
        updateRegistry(item, val, label) {
            const registryItem = this.infoRegistryArr.find(
                (i) => i.id === item.id
            );
            const field = registryItem.fields.find(
                (i) => i.column_number == item.fields[label].columnNumber
            );

            field.value = val.toString();

            MonitoringSnpApi.put(`/snp/api/v1/registry/update`, registryItem)
                .then((res) => {
                    if (res.status === 200) {
                        const data = res.data.fields.find(
                            (i) =>
                                i.column_number ===
                                item.fields[label].columnNumber
                        );
                        item.fields[label].value = data.value;
                        item.fields[label].isEdit = true;
                        const infoRegistryItem = this.infoRegistryArr.find(
                            (i) => i.id === item.id
                        );
                        const infoRegistryField = infoRegistryItem.fields.find(
                            (i) =>
                                i.column_number ===
                                item.fields[label].columnNumber
                        );
                        infoRegistryField.value = data.value;
                    }
                })
                .catch(() => {
                    this.makeToast(
                        "danger",
                        "Не удалось обновить данные",
                        "Ошибка"
                    );
                    return;
                });
        },
        makeToast(variant = null, toastBody, title) {
            this.$bvToast.toast(toastBody, {
                title: title,
                variant: variant,
                autoHideDelay: 4000,
                solid: true,
            });
        },
        setRegion(region) {
            this.editRegionVal = region;
            if (this.editDistrictVal.id) {
                this.getKatoChildren(this.editDistrictVal.id)
                    .then((res) => {
                        this.createSnpArr = res.data;
                        this.editSnpVal = this.createSnpArr.find(
                            (item) =>
                                item.nameRu === this.selectedSchool.address_name
                        );
                    })
                    .catch(() => null);
            }
        },
        transformRegistryResponse(responseData) {
            // responseData = res.data.data (объект {formCode, formGroup, catoCode, yearGroups})
            const catoCode = responseData?.catoCode || "";
            const formGroup = responseData?.formGroup;
            const region_code =
                catoCode.length >= 3 ? catoCode.substring(0, 3) + "000000" : "";
            const district_code =
                catoCode.length >= 6 ? catoCode.substring(0, 6) + "000" : "";

            const yearGroups = responseData?.yearGroups || {};
            const availableYears = Object.keys(yearGroups);
            let yearKey = String(this.yearVal);
            if (!yearGroups[yearKey]) {
                if (this.yearVal === null || this.yearVal === undefined) {
                    // год ещё не проставился — берём самый свежий из ответа,
                    // иначе реестр отрисуется пустым без каких-либо сообщений
                    yearKey = availableYears.sort()[availableYears.length - 1];
                } else {
                    console.warn(
                        `Реестр: в ответе нет данных за ${this.yearVal}`,
                        availableYears
                    );
                }
            }
            const yearItems = yearGroups[yearKey] || [];
            const headersArr = Array.isArray(this.reportHeadersArr)
                ? this.reportHeadersArr
                : [];

            return yearItems.map((item) => {
                const fields = (item.data || [])
                    .filter((ind) => ind.name?.ru !== "КАТО")
                    .map((ind, idx) => {
                        const header = headersArr.find(
                            (h) => h.description === ind.name?.ru
                        );
                        const paramsStr =
                            ind.params && ind.params !== "null"
                                ? ind.params
                                : null;
                        const parsedParams = paramsStr
                            ? (() => {
                                  try {
                                      return JSON.parse(paramsStr);
                                  } catch {
                                      return null;
                                  }
                              })()
                            : null;
                        // нумерация как в старом формате: ID=2, Школа=3, ...
                        const columnNumber = header?.columnNumber ?? idx + 2;
                        return {
                            head: ind.name?.ru,
                            description: ind.name?.ru,
                            value: ind.value ?? null,
                            column_number: columnNumber,
                            columnNumber,
                            id: ind.indicatorCode,
                            indicatorCode: ind.indicatorCode,
                            formGroup,
                            editable:
                                parsedParams != null
                                    ? parsedParams.editable
                                    : true,
                            params: paramsStr,
                        };
                    });
                return {
                    id: item.objectId,
                    code: catoCode,
                    name: item.name?.ru,
                    snp: this.selectedSnpLabel || this.selectedRegionLabel,
                    address_name: item.name?.ru,
                    year: Number(yearKey) || this.yearVal,
                    region_code,
                    district_code,
                    fields: fields,
                };
            });
        },
        getSchoolInfo(data, isAfterSelectedTemp) {
            this.selectedSchool = {};
            this.controlMap = [];
            if (!isAfterSelectedTemp) {
                const selected = this.infoRegistryArr.find(
                    (item) => item.id === data.id
                );
                if (!selected) return;
                // полный набор полей (fields в globalArr усечены initSectionValue)
                this.reportHeadersArr = selected.fields;
                this.searchReportHeadersArr = selected.fields;
                this.selectedSchool = {
                    ...selected,
                    fields: selected.fields.map((item) => {
                        const elem = this.reportHeadersArr.find(
                            (elem) => item.column_number === elem.columnNumber
                        );
                        const params =
                            elem && elem.params && JSON.parse(elem.params);
                        const isList =
                            params &&
                            params.values &&
                            params.values.every(
                                (item) => !item.startsWith("id_")
                            ) &&
                            params.values.filter((item) =>
                                [
                                    "+",
                                    "-",
                                    "/",
                                    "*",
                                    "<",
                                    ">",
                                    "=",
                                    "<=",
                                    ">=",
                                ].includes(item)
                            ).length === 0;
                        const editable = params && params.editable;
                        let value = item.value;

                        if (params) {
                            if (value && value.length) {
                                if (params.multiple_choice) {
                                    value =
                                        item.value.split(", ").map(
                                            (item) =>
                                                item.length && {
                                                    value: item,
                                                }
                                        ) || [];
                                } else if (isList) {
                                    value = { value: item.value };
                                }
                            } else {
                                value = null;
                            }
                        }

                        return {
                            ...item,
                            ...elem,
                            params,
                            isList,
                            value,
                            editable,
                        };
                    }),
                };

                if (!isEmpty(this.selectedSchool)) {
                    const temp = [];
                    this.reportHeadersArr.forEach((element) => {
                        const elem = this.selectedSchool.fields.find(
                            (x) => x.head === element.description
                        );
                        if (!elem) return;
                        if (elem.column_number === 6 && elem.value === null) {
                            elem.value = this.selectedSchool.name;
                        }
                        if (!isEmpty(elem)) {
                            temp.push({ ...elem });
                        }
                    });
                    this.selectedSchool.fields = temp;

                    this.isSchoolEdit =
                        this.checkIsSchoolEdit(
                            this.selectedSchool.code,
                            "ROLE_SNP_VILLAGE"
                        ) ||
                        this.checkIsSchoolEdit(
                            this.selectedSchool.code,
                            "ROLE_SNP_DISTRICT"
                        );

                    const region =
                        this.regions.find(
                            (item) =>
                                item.code.toString() ===
                                this.selectedSchool.region_code
                        ) || this.regionVal;
                    if (region?.id) {
                        this.getKatoChildren(region?.id)
                            .then((result) => {
                                this.editDistrictArr = result.data;
                                this.editDistrictVal =
                                    this.editDistrictArr.find(
                                        (item) =>
                                            item.code.toString() ===
                                            this.selectedSchool.district_code
                                    ) || this.districtVal;
                                this.setRegion(region);
                            })
                            .catch(() => null);
                    } else {
                        this.editRegionVal = this.regionVal;
                        this.editDistrictArr = this.createDistrictArr.length
                            ? this.createDistrictArr
                            : this.districtArr.filter(
                                  (d) => d.nameRu !== "Все"
                              );
                        this.editDistrictVal = this.districtVal;
                    }
                    this.editModalVisible = true;
                }
            }

            if (isAfterSelectedTemp) {
                const formCode = this.registryVal.formCode;
                MonitoringSnpApi.get(
                    `/snp/api/v1/form/registry/${formCode}/${data.code}`,
                    { year: this.yearVal }
                )
                    .then((res) => {
                        if (res.status === 200) {
                            this.infoRegistryArr =
                                this.transformRegistryResponse(res.data?.data);
                            const selected = this.infoRegistryArr.find(
                                (item) => item.name === data.name
                            );
                            this.selectedSchool = { ...selected };

                            if (!isEmpty(this.selectedSchool)) {
                                this.isSchoolEdit =
                                    this.checkIsSchoolEdit(
                                        this.selectedSchool.code,
                                        "ROLE_SNP_VILLAGE"
                                    ) ||
                                    this.checkIsSchoolEdit(
                                        this.selectedSchool.code,
                                        "ROLE_SNP_DISTRICT"
                                    );
                                this.editModalVisible = true;
                                this.getKatoInfoByCode(
                                    this.selectedSchool.code
                                );
                            }
                        }
                    })
                    .catch(() => (this.loading = false))
                    .finally(() => (this.loading = false));
            }
        },
        checkIsSchoolEdit(code, role) {
            return (
                this.checkRole(role) &&
                this.me.katoCodes.includes(code.toString())
            );
        },
        resetFrom() {
            const self = this;
            if (this.formRegistry !== undefined) {
                Object.keys(this.formRegistry).forEach(function (key) {
                    if (
                        self.formRegistry[key].description !== "Район" &&
                        self.formRegistry[key].description !== "СНП"
                    ) {
                        self.formRegistry[key].value = "";
                    }
                });
            }
        },
        createRegistry() {
            this.resetFrom();
            this.controlMap = [];
            if (
                this.me.initialSnp === undefined ||
                this.me.initialSnp === null
            ) {
                this.makeToast(
                    "danger",
                    "Пользователь не прикрпелен к региону",
                    "Ошибка"
                );
                return;
            }
            this.loading = true;
            this.newItem = {};
            this.createRegionVal = this.regionVal;
            this.createDistrictVal = this.districtVal;
            this.createSnpVal = this.snpVal;
            if (!isEmpty(this.createDistrictVal)) {
                this.loadAllSnp(this.createDistrictVal.code);
            } else {
                this.loadAllSnp(this.createRegionVal.code);
            }

            setTimeout(() => {
                this.createModalVisible = true;
                this.loading = false;
            }, 2000);
        },
        editRegistry() {
            if (this.controlMap.some((item) => Boolean(item))) {
                [
                    ...new Set(
                        this.notificationArray.map(({ type, msg, title }) =>
                            JSON.stringify({ type, msg, title })
                        )
                    ),
                ]
                    .map(JSON.parse)
                    .forEach(({ type, msg, title }) =>
                        this.makeToast(type, msg, title)
                    );
                return;
            }

            const isRoads = this.isRoadsRegistry;
            const myForm = document.getElementById("editFrm");
            const formData = new FormData(myForm);
            const formValue = {};

            for (const [key, val] of formData.entries()) {
                Object.assign(formValue, { [key]: val });
            }

            this.selectedSchool.fields.forEach((item) => {
                if (item.value) {
                    if (item.column_number === 5 && !isRoads) {
                        item.value = this.editRegionVal?.nameRu ?? item.value;
                    } else if (item.column_number === 3 && isRoads) {
                        item.value =
                            this.editRegionVal?.nameRu.split(" ")[0] ??
                            item.value;
                    } else if (
                        !isNaN(item.value) &&
                        item.params?.data_type === "integer"
                    ) {
                        item.value = +item.value;
                    } else if (
                        !isNaN(item.value) &&
                        item.params?.data_type === "float"
                    ) {
                        item.value = +(+item.value).toFixed(2);
                    } else if (item.params && item.params.multiple_choice) {
                        item.value =
                            item.value.map((elem) => elem.value).join(", ") ??
                            "";
                    } else if (item.isList) {
                        item.value = item.value?.value;
                    }
                } else {
                    if (item.params && item.params.multiple_choice) {
                        item.value = item.value?.length
                            ? item.value.map((elem) => elem.value).join(", ")
                            : "";
                    } else {
                        item.value = null;
                    }
                }
            });
            const editCatoCode = String(
                (this.selectedSchool.type === 12
                    ? this.editSnpVal?.code
                    : this.editRegionVal?.code) || this.selectedSchool.code
            );

            const editRequestBody = [];

            this.selectedSchool.fields.forEach((item) => {
                if (item.indicatorCode) {
                    editRequestBody.push({
                        formGroup: item.formGroup || 1,
                        indicatorCode: item.indicatorCode,
                        value:
                            item.value !== null && item.value !== undefined
                                ? String(item.value)
                                : null,
                        catoCode: editCatoCode,
                        year: this.selectedSchool.year,
                        headerId: this.selectedSchool.id,
                    });
                }
            });

            MonitoringSnpApi.post(
                `/snp/api/v1/form/registry`,
                editRequestBody,
                {
                    "secret-key": this.secretKey,
                }
            )
                .then((res) => {
                    if (res.status === 200 || res.status === 201) {
                        this.makeToast("info", "Успешно сохранен", "Успешно");
                        this.editModalVisible = false;
                        this.getSnpData(this.isTemplate);
                        this.getReconciliation();
                    }
                })
                .catch((err) =>
                    this.makeToast(
                        "danger",
                        "Не удалось сохранить изменения",
                        "Ошибка"
                    )
                )
                .finally(() => {
                    this.loading = false;
                });

            this.editModalVisible = false;
        },
        saveRegistry() {
            if (this.controlMap.some((item) => Boolean(item))) {
                [
                    ...new Set(
                        this.notificationArray.map(({ type, msg, title }) =>
                            JSON.stringify({ type, msg, title })
                        )
                    ),
                ]
                    .map(JSON.parse)
                    .forEach(({ type, msg, title }) =>
                        this.makeToast(type, msg, title)
                    );
                return;
            }

            const myForm = document.getElementById("frm");
            const formData = new FormData(myForm);
            const formValue = {};
            for (const [key, val] of formData.entries()) {
                Object.assign(formValue, { [key]: val });
            }
            const isRoads = this.isRoadsRegistry;
            if (
                !isRoads &&
                (!this.createDistrictVal || !this.createSnpVal)
            ) {
                this.makeToast(
                    "danger",
                    "Вы не ввели обязательные поля Район, Сельский округ, СНП",
                    "Ошибка"
                );
                return;
            }
            const nameRu = !isRoads
                ? formValue["item_field_3"]
                : formValue["item_field_6"];
            const catoCode = String(
                !isRoads
                    ? this.createSnpVal.code
                    : this.createRegionVal.code
            );

            const requestBody = [];

            this.formRegistry.forEach((item) => {
                if (this.notVisible.indexOf(item.description) === -1) {
                    let value = item.value;

                    if (value) {
                        if (
                            !isNaN(item.value) &&
                            item.params?.data_type === "integer"
                        ) {
                            value = +item.value;
                        } else if (
                            !isNaN(item.value) &&
                            item.params?.data_type === "float"
                        ) {
                            value = +(+item.value).toFixed(2);
                        } else if (item.params && item.params.multiple_choice) {
                            value = item.value.length
                                ? item.value
                                      .map((elem) => elem.value)
                                      .join(", ")
                                : "";
                        } else if (item.isList) {
                            value = item.value?.value;
                        }
                    } else {
                        if (
                            item.params?.data_type === "integer" ||
                            item.params?.data_type === "float"
                        ) {
                            value = null;
                        } else if (item.params && item.params.multiple_choice) {
                            value = item.value?.length
                                ? item.value
                                      .map((elem) => elem.value)
                                      .join(", ")
                                : "";
                        } else if (item.isList) {
                            value = null;
                        } else if (item.params?.data_type === "string") {
                            value = "";
                        }
                    }

                    if (!isRoads) {
                        if (item.columnNumber === 5) {
                            value = this.createRegionVal.nameRu ?? item.value;
                        } else if (item.columnNumber === 7) {
                            value = this.createSnpVal.nameRu ?? item.value;
                        } else if (item.columnNumber === 6) {
                            value = this.createDistrictVal.nameRu ?? item.value;
                        }
                    } else {
                        if (item.columnNumber === 3) {
                            value = this.createRegionVal.nameRu;
                        }
                    }

                    requestBody.push({
                        formGroup: item.formGroup || 1,
                        indicatorCode: item.id,
                        value:
                            value !== null && value !== undefined
                                ? String(value)
                                : null,
                        catoCode,
                        year: this.yearVal,
                        nameRu,
                        nameKk: null,
                        nameEn: null,
                    });
                }
            });

            if (
                requestBody.some((row) => {
                    const header = this.reportHeadersArr.find(
                        (h) => h.id === row.indicatorCode
                    );
                    const params = header?.params
                        ? JSON.parse(header.params)
                        : null;
                    return (
                        params?.required &&
                        (row.value === null ||
                            row.value === undefined ||
                            row.value === "")
                    );
                })
            ) {
                this.makeToast(
                    "danger",
                    "Вы не ввели обязательные поля",
                    "Ошибка"
                );
                return;
            }

            MonitoringSnpApi.post(`/snp/api/v1/form/registry`, requestBody, {
                "secret-key": this.secretKey,
            })
                .then((res) => {
                    if (res.status === 200 || res.status === 201) {
                        this.makeToast("info", "Успешно сохранен", "Успешно");
                        this.createModalVisible = false;
                        this.getSnpData(this.isTemplate);
                        this.getReconciliation();
                    }
                })
                .catch((err) =>
                    this.makeToast("danger", "Не удалось создать", "Ошибка")
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        loadTemplates() {
            MonitoringSnpApi.get(`/snp/api/v1/registry/templates`)
                .then((res) => {
                    if (res.status === 200) {
                        this.templateArr = res.data;
                    }
                })
                .catch((err) => console.log(err));
        },
        saveTemplate() {
            if (this.templateName.trim() === "") {
                this.makeToast(
                    "danger",
                    "Вы не ввели наименование шаблона",
                    "Ошибка"
                );
                return false;
            }
            const code = {};
            const selectedVal = {};
            const selTemplate = this.templateArr.find(
                (template) => template.name === this.templateVal
            );
            if (selTemplate !== null && selTemplate !== undefined) {
                code.katoCode = selTemplate.code;
            }
            if (this.snpVal?.code) {
                code.katoCode = this.snpVal.code;
                selectedVal.id = this.snpVal.id;
                this.katoCodeValue = this.snpVal.code;
            } else if (this.districtVal?.code) {
                code.katoCode = this.districtVal.code;
                selectedVal.id = this.districtVal.id;
                this.katoCodeValue = this.districtVal.code;
            } else if (this.regionVal?.code) {
                code.katoCode = this.regionVal.code;
                selectedVal.id = this.regionVal.id;
                this.katoCodeValue = this.regionVal.code;
            }
            let valueInfo = {};
            const registryId = this.registryVal.id;

            this.currentHeads.forEach((item, index) => {
                const valueInfos = [];
                this.globalArr.forEach((gItem, indexGlobal) => {
                    const v = gItem.fields.find((i) => i.head === item.desc);
                    valueInfo = {
                        value: v.value,
                        address: {
                            region: this.regionVal?.nameRu,
                            district: "",
                            snp: gItem.snp,
                            code: gItem.code,
                        },
                        additional_index: gItem.name,
                    };
                    valueInfos.push(valueInfo);
                });
                this.sections[index].first = {
                    year: this.yearVal,
                    values: valueInfos,
                    columnNumber: item.columnNumber,
                };
            });
            const body = {
                name: this.templateName,
                reportId: registryId,
                sections: this.sections,
            };

            if (this.regionVal === null) {
                this.makeToast("danger", "Вы не выбрали район", "Ошибка");
                return false;
            }
            MonitoringSnpApi.post("/snp/api/v1/report/template/save", body)
                .then((res) => {
                    if (res.status === 200) {
                        this.makeToast(
                            "info",
                            "Шаблон успешно сохранен",
                            "Успешно"
                        );
                        this.saveTemplateModalVisible = false;
                        this.loadTemplates();
                    }
                })
                .catch((err) => {
                    this.makeToast("danger", err, "Ошибка!!!");
                });
        },
        canSaveOrAdd() {
            return (
                (this.roles.ADMIN ||
                    (this.isSchoolsSelectedRegistry && this.roles.VILLAGE) ||
                    (this.isRoadsSelectedRegistry &&
                        this.roles.DISTRICT_DEPARTMENTS)) &&
                (this.reconciliation.status === SEND_TO_REPROCESS ||
                    this.reconciliation.status === IN_PROCESS) &&
                ((this.regionVal?.code &&
                    this.me.katoCodes.includes(
                        this.regionVal.code.toString()
                    )) ||
                    (this.isSchoolsSelectedRegistry &&
                        this.snpVal?.code &&
                        this.me.katoCodes.includes(
                            this.snpVal.code.toString()
                        )))
            );
        },
        canSendToApprove() {
            const { VILLAGE, ADMIN, DISTRICT_DEPARTMENTS } = this.roles;
            const nextStatus = this.getNextAvailableStatus();

            return (
                (ADMIN ||
                    VILLAGE ||
                    (DISTRICT_DEPARTMENTS &&
                        this.isRoadsSelectedRegistry)) &&
                nextStatus === SEND_TO_APPROVE &&
                ((this.isSchoolsSelectedRegistry &&
                    this.snpVal?.code &&
                    this.me.katoCodes.includes(this.snpVal?.code.toString())) ||
                    (this.regionVal?.code &&
                        this.me.katoCodes.includes(
                            this.regionVal.code.toString()
                        ))) &&
                this.progress === 100
            );
        },
        canReconcile() {
            const { DISTRICT, ADMIN, DISTRICT_DEPARTMENTS } = this.roles;
            const nextStatus = this.getNextAvailableStatus();

            return (
                this.regionVal?.code &&
                this.me.katoCodes.includes(this.regionVal.code.toString()) &&
                (((DISTRICT_DEPARTMENTS || ADMIN) &&
                    nextStatus === RECONCILED_BY_DEPARTMENTS) ||
                    ((DISTRICT || ADMIN) && nextStatus === RECONCILED)) &&
                this.progress === 100
            );
        },
        canApprove() {
            const { REGION_DEPARTMENTS, ADMIN, REGION } = this.roles;
            const nextStatus = this.getNextAvailableStatus();

            return (
                this.regionVal?.code &&
                this.me.katoCodes.includes(this.regionVal.code.toString()) &&
                (((REGION_DEPARTMENTS || ADMIN) &&
                    (nextStatus === APPROVED_BY_DEPARTMENTS ||
                        nextStatus === APPROVED_BY_ADDITIONAL_DEPARTMENTS)) ||
                    ((REGION || ADMIN) && nextStatus === APPROVED))
            );
        },
        canSendToReprocess() {
            return (
                ((((this.isSchoolsSelectedRegistry && this.roles.VILLAGE) ||
                    this.roles.DISTRICT ||
                    this.roles.ADMIN) &&
                    this.reconciliation.status === SEND_TO_APPROVE) ||
                    ((this.roles.REGION_DEPARTMENTS ||
                        this.roles.DISTRICT_DEPARTMENTS ||
                        this.roles.ADMIN) &&
                        this.reconciliation.status === RECONCILED) ||
                    ((this.roles.REGION || this.roles.ADMIN) &&
                        (this.reconciliation.status ===
                            APPROVED_BY_DEPARTMENTS ||
                            this.reconciliation.status ===
                                APPROVED_BY_ADDITIONAL_DEPARTMENTS)) ||
                    (this.roles.ADMIN &&
                        this.reconciliation.status === APPROVED) ||
                    (this.roles.DISTRICT &&
                        this.reconciliation.status ===
                            RECONCILED_BY_DEPARTMENTS)) &&
                ((this.regionVal?.code &&
                    this.me.katoCodes.includes(
                        this.regionVal.code.toString()
                    )) ||
                    (this.isSchoolsSelectedRegistry &&
                        this.snpVal?.code &&
                        this.me.katoCodes.includes(
                            this.snpVal.code.toString()
                        )))
            );
        },
        sendToApprove() {
            this.handleAction(SEND_TO_APPROVE);
        },
        reconcile() {
            const status = this.getNextAvailableStatus();
            this.handleAction(status);
        },
        approve() {
            const status = this.getNextAvailableStatus();
            this.handleAction(status);
        },
        sendToReprocess() {
            this.handleAction(SEND_TO_REPROCESS);
        },
        handleAction(status) {
            const data = [
                { reconciliationId: this.reconciliation?.id, status },
            ];
            const statusName = this.hierarchy.find(
                (item) => item.status === status
            )?.name_ru;
            MonitoringSnpApi.post("/snp/api/v1/reconciliation", data)
                .then((res) => {
                    this.reconciliation = res.data.data[0];
                    this.makeToast(
                        "success",
                        `Новый статус паспорта - ${statusName}`,
                        "Успешно"
                    );
                })
                .catch((err) => {
                    this.makeToast(
                        "danger",
                        "Произошла ошибка на сервере",
                        "Ошибка"
                    );
                });
        },
        getReconciliation() {
            const snpVal = this.snpVal?.code || this.me.initialSnp?.katoCode;
            // сверка ведётся только по СНП (иначе бэкенд отвечает 404): у кодов
            // области, района и округа последние три цифры — «000»
            const isSnpCode = snpVal && !String(snpVal).endsWith("000");
            // реестр школ согласуется по СНП, реестр дорог — по региону
            const katoCode = this.isRoadsRegistry
                ? this.regionVal?.code
                : isSnpCode
                ? snpVal
                : null;
            const formCode = this.registryVal?.formCode || "F012";
            // без года запрос уходит с ?year=undefined и получает 400; сверку
            // запросит вотчер yearsArr, когда придут годы
            if (!katoCode || !this.yearVal) {
                return Promise.resolve();
            }
            return MonitoringSnpApi.get(
                `/snp/api/v1/reconciliation/${katoCode}/${formCode}`,
                { year: this.yearVal }
            )
                .then((res) => {
                    this.reconciliation = res.data?.data || {};
                    this.progress = this.reconciliation.progress;
                })
                .catch((err) => {
                    console.warn("getReconciliation", err);
                });
        },
        handleChangeValue(item, index, type = "edit") {
            const params = item.params;
            const values =
                params?.values?.map((item) => item.toLowerCase().trim()) || [];
            const data_type = params?.data_type;
            const fields =
                type === "edit"
                    ? this.selectedSchool.fields
                    : this.formRegistry;
            const control = {
                isMoreThan: false,
                isMoreThan100: false,
                isLessThan0: false,
                isEmpty: false,
            };

            if (params?.control?.less_than) {
                control.isMoreThan =
                    +item.value >
                    +fields.find((elem) => elem.id === params.control.less_than)
                        .value;
            }

            fields.forEach((element, index) => {
                if (element.params && element.params.control?.less_than) {
                    const foundItem = fields.find(
                        (x) => x.id === element.params.control?.less_than
                    );
                    this.controlMap[index] =
                        +fields[index].value > +foundItem.value;
                    if (this.controlMap[index]) {
                        this.notificationArray.push({
                            type: "danger",
                            msg: element.params.message,
                            title: "Ошибка",
                            id: index,
                        });
                    }
                }
            });

            if (values.includes("<=") && values.includes("100")) {
                control.isMoreThan100 = +item.value > 100;
            }

            if (
                fields.some(
                    (field) =>
                        field.params &&
                        field.params.values?.includes("id_" + item.id)
                )
            ) {
                fields.forEach((field, index) => {
                    if (
                        field.params &&
                        field.params?.values?.includes("id_" + item.id)
                    ) {
                        const stack = [];
                        field.params.values.forEach((elem) => {
                            if (elem.startsWith("id_")) {
                                const foundById = fields.find(
                                    (element) => element.id === +elem.slice(3)
                                );
                                stack.push(+foundById.value);
                            } else if (["+", "-", "*", "/"].includes(elem)) {
                                const last = stack[stack.length - 1] || 0;
                                const prevLast = stack[stack.length - 2] || 0;
                                stack.pop();
                                stack.pop();
                                if (elem === "+") {
                                    stack.push(+last + +prevLast);
                                } else if (elem === "-") {
                                    stack.push(+prevLast - +last);
                                } else if (elem === "*") {
                                    stack.push(+last * +prevLast);
                                } else {
                                    if (+prevLast === +last) {
                                        stack.push(1);
                                    } else {
                                        stack.push(+prevLast / (+last || 1));
                                    }
                                }
                            } else {
                                stack.push(+elem);
                            }
                        });
                        field.value = stack[0];
                        stack.length = 0;
                    }
                });
            }

            if (this.isRoadsRegistry) {
                const total = fields.find((item) => item.columnNumber === 7);

                const first = fields.find((item) => item.columnNumber === 12);
                const second = fields.find((item) => item.columnNumber === 14);
                const third = fields.find((item) => item.columnNumber === 16);

                const firstPercentage = fields.find(
                    (item) => item.columnNumber === 13
                );
                const secondPercentage = fields.find(
                    (item) => item.columnNumber === 15
                );
                const thirdPercentage = fields.find(
                    (item) => item.columnNumber === 17
                );

                if (
                    +first.value + +second.value + +third.value >
                    +total.value
                ) {
                    this.controlMap[fields.indexOf(first)] = 1;
                    this.controlMap[fields.indexOf(second)] = 1;
                    this.controlMap[fields.indexOf(third)] = 1;
                    this.notificationArray.push({
                        type: "danger",
                        msg: first.params.message,
                        title: "Ошибка",
                        id: fields.indexOf(first),
                    });
                } else {
                    this.controlMap[fields.indexOf(first)] = 0;
                    this.controlMap[fields.indexOf(second)] = 0;
                    this.controlMap[fields.indexOf(third)] = 0;
                    this.notificationArray = this.notificationArray.filter(
                        (element) => element.id !== fields.indexOf(first)
                    );
                }

                fields[fields.indexOf(firstPercentage)].value =
                    +(+first.value / +total.value) * 100;
                fields[fields.indexOf(secondPercentage)].value =
                    +(+second.value / +total.value) * 100;
                fields[fields.indexOf(thirdPercentage)].value =
                    +(+third.value / +total.value) * 100;

                if (type === "create") {
                    this.refresh();
                }

                return;
            }

            if (item.value === null || item.value === "") {
                control.isEmpty = true;
            }

            if (data_type === "integer" || data_type === "float") {
                control.isLessThan0 = item.value < 0;
            }

            if (Object.values(control).some((item) => item)) {
                if (control.isMoreThan || control.isMoreThan100) {
                    this.notificationArray.push({
                        type: "danger",
                        msg: params.message,
                        title: "Ошибка",
                        id: index,
                    });
                    this.controlMap[index] = 1;
                } else if (control.isLessThan0) {
                    this.notificationArray.push({
                        type: "danger",
                        msg: "Значение не должно быть меньше 0",
                        title: "Ошибка",
                        id: index,
                    });
                    this.controlMap[index] = 1;
                }
            } else {
                this.controlMap[index] = 0;
            }

            if (type === "create") {
                this.refresh();
            }

            this.removeNotifications();
        },
        refresh() {
            this.formRegistry.reverse().reverse();
            this.controlMap.reverse().reverse();
        },
        getRegistryForm() {
            this.formRegistry = this.reportHeadersArr.map((item) => {
                const params = item.params && JSON.parse(item.params);
                const isList =
                    params &&
                    params.values &&
                    params.values.every((elem) => !elem.startsWith("id_")) &&
                    params.values.filter((elem) =>
                        [
                            "+",
                            "-",
                            "/",
                            "*",
                            "<",
                            ">",
                            "=",
                            "<=",
                            ">=",
                        ].includes(elem)
                    ).length === 0;
                const editable = params && params.editable;

                return {
                    ...item,
                    params,
                    isList,
                    editable,
                };
            });
        },
        removeNotifications() {
            this.controlMap.forEach((item, index) => {
                if (
                    item === 0 &&
                    this.notificationArray.find((item) => +item.id === +index)
                ) {
                    this.notificationArray = this.notificationArray.filter(
                        (element) => element.id !== index
                    );
                }
            });
        },
        openDeleteModal() {
            this.deleteModalVisible = true;
        },
        deleteRegistry() {
            MonitoringSnpApi.delete(
                `/snp/api/v1/form/registry/${this.selectedSchool.id}`,
                { headers: { "secret-key": this.secretKey } }
            )
                .then(() => {
                    this.getSnpData(this.isTemplate);
                    this.getReconciliation();
                    this.makeToast("success", `Объект был удален`, "Успешно");
                    this.deleteModalVisible = false;
                    this.editModalVisible = false;
                })
                .catch((err) => {
                    this.makeToast(
                        "danger",
                        `Не удалось удалить объект`,
                        "Ошибка"
                    );
                });
        },
        formatDate(date) {
            return moment(date).format("DD.MM.YYYY HH:mm");
        },
        loadHistory() {
            const params = {
                year: this.yearVal,
                formCode:
                    this.selectedRegistry?.formCode ||
                    (this.isRoadsSelectedRegistry ? "F013" : "F012"),
            };

            const cato_code =
                this.currentSnp?.code ||
                this.me.katoCodes[this.me.katoCodes.length - 1];
            this.historyLoading = true;
            MonitoringSnpApi.get(
                `/snp/api/v1/reconciliation/${cato_code}/history`,
                params
            )
                .then(({ data }) => {
                    const dataWithRuNames = data.data.map((item) => ({
                        ...item,
                        name_ru:
                            item.toStatus === "SEND_TO_REPROCESS"
                                ? "Отправлена на доработку"
                                : this.hierarchy.find(
                                      (elem) => elem.status === item.toStatus
                                  )?.name_ru,
                    }));
                    this.historyData = dataWithRuNames;
                    this.historyLoading = false;
                })
                .catch(() => (this.historyLoading = false));
        },
        getHierarchy() {
            const id = ["F013"].includes(this.registryVal) ? 7 : 12;
            MonitoringSnpApi.get(`/snp/api/v1/instruction/report/${id}`)
                .then((res) => {
                    this.hierarchy = res.data;
                })
                .catch(() => {
                    this.makeToast(
                        "danger",
                        "Ошибка при получении иерархии",
                        "Ошибка"
                    );
                });
        },
        getNextAvailableStatus() {
            const status =
                this.reconciliation?.status === "SEND_TO_REPROCESS"
                    ? "IN_PROCESS"
                    : this.reconciliation?.status;

            const currentStatus = this.hierarchy?.find(
                (item) => item.status === status
            );

            return currentStatus
                ? this.hierarchy?.find(
                      (item) => item.id === currentStatus?.next
                  )?.status
                : this.hierarchy?.find((item) => item.previous === null).status;
        },
        getCurrentStatusName() {
            const currentStatus = this.reconciliation?.status;

            if (currentStatus === "SEND_TO_REPROCESS") {
                return "Отправлена на доработку";
            } else {
                return this.hierarchy?.find(
                    (item) => item.status === currentStatus
                )?.name_ru;
            }
        },
        isRequired(fieldName) {
            return this.isRoadsRegistry
                ? this.roadRequiredFields.includes(fieldName)
                : this.schoolRequiredFields.includes(fieldName);
        },
        downloadStaticFile(id) {
            const url = `/snp/api/v1/report/file/infoTemplate/${id}`;
            const name =
                +id === 1
                    ? "СВОД 2022-I полугодие.xlsx"
                    : "Режим Мониторинг СНП.pdf";
            Ax(
                {
                    url,
                    method: "GET",
                    data: null,
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.token}`,
                    },
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", name);
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    console.log("err", error);
                }
            );
        },
    },
};
</script>

<style>
/*.actions-tab.in-tab .dropdown-menu {*/
/*    margin-top: -90px;*/
/*}*/
</style>

<style lang="scss" scoped>
.spinner {
    padding-top: calc(100vh / 3.3);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #eef1f8;
}

li {
    cursor: pointer;
}

li:hover {
    background-color: #f6f6f6;
}

input.form-control {
    max-width: 100%;
}

.mr-sm-2 {
    font-size: 14px;
    width: 50%;
    justify-content: left;
    color: #6087a0;
}

.col-border {
    border: 1px solid red;
}

.input-group-text {
    background-color: #ffffff;
}

.cursor-point {
    cursor: pointer;
}

.selected-snp {
    margin-left: 20px;
    color: #1c2a3e;
    font-weight: 700;
    font-size: 14px;
    display: flex;
    gap: 10px;
    align-items: center;
}

h5.modal-title {
    width: 100%;
}

.filter-container {
    flex-wrap: wrap;
    height: auto;
    gap: 8px;
    padding: 8px 20px;
}

.filter-actions {
    display: flex;
    flex-wrap: nowrap;
    overflow: auto hidden;

    & > button {
        white-space: nowrap;
    }
}

.control-error {
    color: #c0504c !important;
    border: 2px solid #c0504c !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}

.no-wrap {
    display: flex;
    gap: 0;
    column-gap: 3rem;
}

.multiselect {
    max-width: 513px;
}

.required {
    position: relative;

    &::after {
        content: "*";
        position: absolute;
        top: 0;
        right: -10px;
        color: red;
    }
}

.required-hint {
    color: red;
    font-size: 12px;
}
</style>
